
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n/i18n.ts'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')

createRoot(container).render(
  <App />
);
